const defaultRouters = [
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/register/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue')
  },
  {
    path: '/licenseExpire',
    name: 'licenseExpire',
    component: () => import(/* webpackChunkName: "licenseExpire" */ '../views/licenseExpire/index.vue')
  },
  {
    path: '/monitorMaintenance',
    name: 'monitorMaintenance',
    component: () => import(/* webpackChunkName: "monitorMaintenance" */ '../views/monitorMaintenance/index.vue'),
    redirect: '/monitorMaintenance/mapMonitor',
    hidden: true,
    children: [
      {
        path: 'deviceMonitor',
        name: 'deviceMonitor',
        component: () =>
          import(/* webpackChunkName: "deviceMonitor" */ '../views/monitorMaintenance/DeviceMonitor.vue'),
        meta: {
          title: '设备监控'
        }
      },
      {
        path: 'productLineMonitor',
        name: 'productLineMonitor',
        component: () =>
          import(/* webpackChunkName: "productLineMonitor" */ '../views/monitorMaintenance/ProductLineMonitor.vue'),
        meta: {
          title: '工厂监控'
        }
      },
      {
        path: 'enterpriseScreen',
        name: 'enterpriseScreen',
        component: () =>
          import(/* webpackChunkName: "enterpriseScreen" */ '../views/monitorMaintenance/EnterpriseScreen.vue'),
        meta: {
          title: '企业大屏'
        }
      }
    ]
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/errorPage/404.vue')
  }
];

export default defaultRouters;
